export const RACE_OPTIONS = [
  'Elf',
  'Dwarf',
  'Half elf',
  'Half Orc',
  'Human',
  'Halfling',
  'Gnome',
  'Drow (UA)',
  'Deep Gnome (UA)'
];

const escapeAttr = (value = '') =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;');

const escapeHTML = (value = '') =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

const normalizeOptionValue = (value = '') => String(value || '').trim();

export const getOptionList = (options, currentValue = '') => {
  const current = normalizeOptionValue(currentValue);
  const normalizedOptions = Array.isArray(options) ? options.map(normalizeOptionValue).filter(Boolean) : [];

  return current && !normalizedOptions.includes(current)
    ? [current, ...normalizedOptions]
    : normalizedOptions;
};

export const renderSelectOptions = (
  options,
  currentValue,
  { placeholder = 'Select an option' } = {}
) => {
  const current = normalizeOptionValue(currentValue);
  const finalOptions = getOptionList(options, current);

  const placeholderOption = `<option value="">${escapeHTML(placeholder)}</option>`;
  const valueOptions = finalOptions
    .map((option) => {
      const selected = option === current ? ' selected' : '';
      return `<option value="${escapeAttr(option)}"${selected}>${escapeHTML(option)}</option>`;
    })
    .join('');

  return placeholderOption + valueOptions;
};

export const renderSingleSelectPills = (options, currentValue = '', { fieldKey = '' } = {}) => {
  const current = normalizeOptionValue(currentValue);
  const finalOptions = getOptionList(options, current);
  const fieldAttr = fieldKey ? ` data-pill-field="${escapeAttr(fieldKey)}"` : '';

  return finalOptions
    .map((option) => {
      const active = option === current ? ' pill-active' : '';
      return `<button type="button" class="pill${active}"${fieldAttr} data-pill-value="${escapeAttr(option)}">${escapeHTML(option)}</button>`;
    })
    .join('');
};
